package com.yendo.mx.ui.theme

import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
val RosaClaroYendo = Color(0xFFFFE4EE)

val RosaYendo = Color(0xFFFF1469)
val YendoGradient = Brush.horizontalGradient(listOf(Color(0xFFFF1469), Color(0xFFFF1493)))